<template>
    <header>
        <div class="navbar-fixed">
            <nav>
                <div class="nav-wrapper">
                    <a href="#" data-target="slide-out" class="sidenav-trigger"><font-awesome-icon size="2x" :icon="['fas', 'bars']"/></a>

                    <a href="#" class="brand-logo"><img src="../assets/images/kiwiplan_logo_off_white.png"></a>
                    <navbar_menu />
                </div>
            </nav>
        </div>
    </header>
</template>
<script>
import Vue from 'vue'
import navbar_menu from '@/components/navbar_menu'


export default {
    name: 'dashboard',
    data(){
        return{
            
        }
    },
    methods:{

    },
    components:{
        navbar_menu
    
    },
    created: function(){

    }
    
}

</script>


// WEBPACK FOOTER //
// src/components/navbar.vue